import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
export var UpcomingNavItem = function UpcomingNavItem(_ref) {
  var count = _ref.count;
  return React.createElement("li", null, React.createElement(Link, {
    to: "/profile/upcoming"
  }, React.createElement(FormattedMessage, {
    id: "header.link.upcoming",
    defaultMessage: "Upcoming"
  }), count > 0 && React.createElement("span", {
    className: "header__badge"
  }, count)));
};
UpcomingNavItem.propTypes = {
  count: PropTypes.number
};